import { mergeAttributes, Node, NodeViewProps } from "@tiptap/core";
import { NodeViewWrapper, ReactNodeViewRenderer } from "@tiptap/react";

// https://tiptap.dev/docs/editor/extensions/custom-extensions/node-views/react

export interface PageBreakBlockOptions {
  HTMLAttributes: Record<string, any>;
  color: string;
  height: number;
  width: number;
  alignment: "left" | "center" | "right";
}

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    PageBreak: {
      setPageBreakBlock: () => ReturnType;
    };
  }
}

const HorizontalLineComponent = ({ node }: NodeViewProps) => {
  return (
    <NodeViewWrapper className="flex flex-row items-center py-2 cursor-pointer">
      <div className="flex-1 h-px border-b border-dashed border-[var(--surface-500)]"></div>

      <div className="pl-1 pr-1 text-[var(--surface-600)]" style={{ minHeight: "22px" }}>
        {"[ PAGE BREAK ]"}
      </div>

      <div className="flex-1 h-px border-b border-dashed border-[var(--surface-500)]"></div>
    </NodeViewWrapper>
  );
};

export const PageBreakBlock = Node.create<PageBreakBlockOptions>({
  name: "pageBreak",

  group: "block",

  content: "",

  selectable: true,

  // this for, @Mentions, project photo, not text stuff
  atom: true,

  addAttributes() {
    return {};
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return ReactNodeViewRenderer(HorizontalLineComponent);
  },

  addCommands() {
    return {
      setPageBreakBlock:
        () =>
        ({ commands }) => {
          return commands.insertContent({ type: "pageBreak" });
        },
    };
  },
});
